import { AnimationContent } from "./AnimationContent";
import { AnimationNodeContent } from "./AnimationNodeContent";
import { KeyFramesContent } from "./KeyFramesContent";
import { IAniLib } from "./AniLibPack";
export class AnimationParser02 {
    static READ_DATA() {
        AnimationParser02._DATA.offset = AnimationParser02._reader.readUint32();
        AnimationParser02._DATA.size = AnimationParser02._reader.readUint32();
    }
    static READ_BLOCK() {
        var count = AnimationParser02._BLOCK.count = AnimationParser02._reader.readUint16();
        var blockStarts = AnimationParser02._BLOCK.blockStarts = [];
        var blockLengths = AnimationParser02._BLOCK.blockLengths = [];
        for (var i = 0; i < count; i++) {
            blockStarts.push(AnimationParser02._reader.readUint32());
            blockLengths.push(AnimationParser02._reader.readUint32());
        }
    }
    static READ_STRINGS() {
        var offset = AnimationParser02._reader.readUint32();
        var count = AnimationParser02._reader.readUint16();
        var prePos = AnimationParser02._reader.pos;
        AnimationParser02._reader.pos = offset + AnimationParser02._DATA.offset;
        for (var i = 0; i < count; i++)
            AnimationParser02._strings[i] = AnimationParser02._reader.readUTFString();
        AnimationParser02._reader.pos = prePos;
    }
    static parse(templet, reader) {
        AnimationParser02._templet = templet;
        AnimationParser02._reader = reader;
        AnimationParser02.READ_DATA();
        AnimationParser02.READ_BLOCK();
        AnimationParser02.READ_STRINGS();
        for (var i = 0, n = AnimationParser02._BLOCK.count; i < n; i++) {
            var index = reader.readUint16();
            var blockName = AnimationParser02._strings[index];
            var fn = AnimationParser02["READ_" + blockName];
            if (fn == null)
                throw new Error("model file err,no this function:" + index + " " + blockName);
            else
                fn.call(null);
        }
    }
    static READ_ANIMATIONS() {
        var reader = AnimationParser02._reader;
        var arrayBuffer = reader.rawBuffer;
        var i, j, k, n, l;
        var keyframeWidth = reader.readUint16();
        var interpolationMethod = [];
        interpolationMethod.length = keyframeWidth;
        for (i = 0; i < keyframeWidth; i++)
            interpolationMethod[i] = IAniLib.AnimationTemplet.interpolation[reader.readByte()];
        var aniCount = reader.readUint8();
        AnimationParser02._templet._anis.length = aniCount;
        for (i = 0; i < aniCount; i++) {
            var ani = AnimationParser02._templet._anis[i] = new AnimationContent();
            ani.nodes = [];
            var aniName = ani.name = AnimationParser02._strings[reader.readUint16()];
            AnimationParser02._templet._aniMap[aniName] = i;
            ani.bone3DMap = {};
            ani.playTime = reader.readFloat32();
            var boneCount = ani.nodes.length = reader.readInt16();
            ani.totalKeyframeDatasLength = 0;
            for (j = 0; j < boneCount; j++) {
                var node = ani.nodes[j] = new AnimationNodeContent();
                node.keyframeWidth = keyframeWidth;
                node.childs = [];
                var nameIndex = reader.readUint16();
                if (nameIndex >= 0) {
                    node.name = AnimationParser02._strings[nameIndex];
                    ani.bone3DMap[node.name] = j;
                }
                node.keyFrame = [];
                node.parentIndex = reader.readInt16();
                node.parentIndex == -1 ? node.parent = null : node.parent = ani.nodes[node.parentIndex];
                ani.totalKeyframeDatasLength += keyframeWidth;
                node.interpolationMethod = interpolationMethod;
                if (node.parent != null)
                    node.parent.childs.push(node);
                var keyframeCount = reader.readUint16();
                node.keyFrame.length = keyframeCount;
                var keyFrame = null, lastKeyFrame = null;
                for (k = 0, n = keyframeCount; k < n; k++) {
                    keyFrame = node.keyFrame[k] = new KeyFramesContent();
                    keyFrame.startTime = reader.readFloat32();
                    (lastKeyFrame) && (lastKeyFrame.duration = keyFrame.startTime - lastKeyFrame.startTime);
                    keyFrame.dData = new Float32Array(keyframeWidth);
                    keyFrame.nextData = new Float32Array(keyframeWidth);
                    var offset = AnimationParser02._DATA.offset;
                    var keyframeDataOffset = reader.readUint32();
                    var keyframeDataLength = keyframeWidth * 4;
                    var keyframeArrayBuffer = arrayBuffer.slice(offset + keyframeDataOffset, offset + keyframeDataOffset + keyframeDataLength);
                    keyFrame.data = new Float32Array(keyframeArrayBuffer);
                    lastKeyFrame = keyFrame;
                }
                keyFrame.duration = 0;
                node.playTime = ani.playTime;
                AnimationParser02._templet._calculateKeyFrame(node, keyframeCount, keyframeWidth);
            }
        }
    }
}
AnimationParser02._strings = [];
AnimationParser02._BLOCK = { count: 0 };
AnimationParser02._DATA = { offset: 0, size: 0 };
